import React from 'react';
import {CMSLandingChat, CMSLandingPostCard} from '@tempo/landing';
import {Button, Flex} from '@tempo/core';
import Link from 'next/link';
import {StrapiOptimizedImage} from './StrapiOptimizedImage';
import {useResolveTranslations} from '../hooks/useResolveTranslations';

type StrapiChatAndPostCardBlockProps = {
	strapiBlockData: any;
	translationNamespace: string;
};

export const StrapiChatAndPostCardBlock: React.FC<
	StrapiChatAndPostCardBlockProps
> = ({strapiBlockData, translationNamespace}) => {
	const resolve = useResolveTranslations(translationNamespace);
	const {chat, postCard} = strapiBlockData;
	const chatMessages = chat?.chatMessages;

	return (
		<Flex
			gap="spacing.xl"
			flexDirection={{base: 'column', md: 'row'}}
			justifyContent="center"
			alignItems={{base: 'center', md: 'center'}}
			mx="auto"
			py="spacing.xl"
		>
			{chatMessages?.length >= 2 && (
				<CMSLandingChat
					title={resolve(chat.title).replace(/<[^>]+>/g, '')}
					cta={
						<Button as={Link} href={chat.cta?.href} variant="outline" w="100%">
							{resolve(chat.cta?.label)}
						</Button>
					}
					items={chatMessages.map((item: any, index: number) => ({
						text: resolve(item.content),
						align: index % 2 === 0 ? 'left' : 'right',
						author: resolve(item.author),
					}))}
				/>
			)}
			{postCard && (
				<CMSLandingPostCard
					title={resolve(postCard.title).replace(/<[^>]+>/g, '')}
					text={resolve(postCard.content).replace(/<[^>]+>/g, '')}
					cta={
						<Button
							as={Link}
							href={postCard.cta?.href}
							variant="onLight"
							w={{base: '100%', md: 'auto'}}
							alignSelf="flex-start"
						>
							{resolve(postCard.cta?.label)}
						</Button>
					}
					author={
						postCard.avatar
							? {
									signoff: resolve(postCard.avatar.signoff),
									image: (
										<StrapiOptimizedImage
											image={postCard.avatar.image?.src}
											alt={resolve(postCard.avatar.image?.alt)}
											sizes="200px"
										/>
									),
								}
							: undefined
					}
				/>
			)}
		</Flex>
	);
};
